import { FC, InputHTMLAttributes, useState, ReactNode } from 'react'
import { InputContainer, InputLabel, InputBox } from './styles'
import { error } from 'console';
import { ValidationError, useErrors } from 'src/context/errors';

export interface StandardInputProps extends InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label: ReactNode;
  labelSize?: 'small' | 'high';
  rows?: number;
  isIncorrect?: boolean;
  errorCode?: string;
  errorMessage?: ReactNode;
  handleBlur?: Function;
}

const StandardInput: FC<StandardInputProps> = ({
  label,
  labelSize,
  rows,
  isIncorrect,
  errorCode = '',
  errorMessage,
  width,
  disabled,
  handleBlur,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false)
  const { hasError, getErrorMessage } = useErrors()

  isIncorrect = hasError(errorCode) || isIncorrect
  errorMessage = getErrorMessage(errorCode) || errorMessage
  
  return (
    <InputContainer>
      {!!label ? (
        <InputLabel labelSize={labelSize ?? 'small'} isIncorrect={labelSize === 'high' ? false : isIncorrect}>
          {label}
        </InputLabel>
      ) : null}
      <InputBox
        isFocused={isFocused}
        isIncorrect={isIncorrect}
        rows={rows}
        width={width}
        disabled={disabled}
      >
        {rows && rows > 0 ? (
          <textarea
            data-error-code={errorCode}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false);
              handleBlur && handleBlur(e);
            }}
            rows={rows}
            disabled={disabled}
            {...rest}
          />
        ) : (
          <input
            data-error-code={errorCode}
            type="text"
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false);
              handleBlur && handleBlur(e);
            }}
            disabled={disabled}
            onWheel={e => {
              if(rest.type === 'number') {
                e.currentTarget.blur()
              }
            }}
            {...rest}
          />
        )}
      </InputBox>
      {!!errorMessage ? (
      <small style={{ whiteSpace: 'normal' }}>{errorMessage}</small>
      ) : null}
    </InputContainer>
  )
}

export default StandardInput